<template>
  <div class="edit_page">
    <div class="edit_wrapper"></div>
    <div class="edit">
      <div class="edit_top">
        <div class="edit_top_buttons">
          <input
            type="button"
            :value="cancelButton"
            class="cancel_button"
            @click="cancel"
          />
          <input
            type="button"
            :value="finishButton"
            class="finish_button"
            @click="update"
          />
        </div>
      </div>
      <div class="detail">
        <div class="detail_contents">
          <div class="system_user_id detail_content">
            <div class="system_user_id_label detail_label">
              {{ adminUserIdLabel }}
            </div>
            {{ adminAccount.adminUserId }}
          </div>
          <div class="system_user_name detail_content">
            <div class="system_user_name_label detail_label">
              {{ adminUserNameLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              v-model="adminAccount.adminUserName"
              @input="inputUpdate('adminUserName')"
              v-bind="attributes"
            />
          </div>
          <div class="authority detail_content">
            <div class="authority_label detail_label">
              {{ authorityLabel }}
            </div>
            <select
              class="drop_down_list"
              @change="inputUpdate('authority')"
              v-bind="attributesDropDownList"
            >
              <option disabled selected value="">{{
                adminAccount.authority
              }}</option>
              <option :value="authority1">{{ authority1 }}</option>
              <option :value="authority2">{{ authority2 }}</option>
            </select>
          </div>
          <div class="mail_address detail_content">
            <div class="mail_address_label detail_label">
              {{ mailAddressLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              v-model="adminAccount.mailAddress"
              @input="inputUpdate('mailAddress')"
              v-bind="attributes"
            />
          </div>
          <div class="password detail_content">
            <div class="password_label detail_label">
              {{ passwordLabel }}
            </div>
            <div class="password_change">
              <input
                type="button"
                :value="passwordChangeButton"
                class="password_change_button"
                @click="showChangePasswordModal = true"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="edit_bottom">
        <input
          type="button"
          :value="deleteButton"
          class="edit_delete_button"
          @click="showDeleteModal = true"
          v-if="!isAdminUserAuthority && !browsingAccountFlg"
        />
      </div>
      <div class="modal_window" v-if="showDeleteModal">
        <deleteModalWindow
          :question="deleteWord"
          :router="router"
          @close="stayClose"
          @remove="remove"
        >
        </deleteModalWindow>
      </div>
      <div class="modal_window" v-if="showChangePasswordModal">
        <changePasswordModalWindow
          :mode="mode"
          @close="stayClose"
          @change="change"
        >
        </changePasswordModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showCompleteModal">
        <completeModalWindow :question="completeWord" @close="close">
        </completeModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showFailureModal">
        <completeModalWindow :question="failureWord" @close="stayClose">
        </completeModalWindow>
      </div>
      <div class="loading_modal_window" v-if="showloadingModal">
        <loadingModalWindow @close="close"> </loadingModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import changePasswordModalWindow from '../modalWindow/changePasswordModalWindow.vue'
import deleteModalWindow from '../modalWindow/detailDeleteModalWindow.vue'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      cancelButton: 'キャンセル',
      finishButton: '完了',
      deleteButton: 'この情報を削除',
      adminUserIdLabel: '管理者ID',
      adminUserNameLabel: '管理者名',
      authorityLabel: '管理者権限',
      authority1: 'ユーザ管理者',
      authority2: '閲覧ユーザ',
      mailAddressLabel: 'メールアドレス',
      passwordLabel: 'パスワード',
      passwordChangeButton: 'パスワード変更',
      router: '/adminAccounts',
      deleteWord: 'この情報を削除してよろしいですか？',
      completeWord: '',
      failureWord: '',
      mode: 'adminAccount',
      showDeleteModal: false,
      showChangePasswordModal: false,
      showCompleteModal: false,
      showloadingModal: false,
      showFailureModal: false,
      attributes: {
        disabled: this.$store.state.masters.browsingAccountFlg,
        class: {disabledColor: this.$store.state.masters.browsingAccountFlg}
      },
      attributesDropDownList: {
        disabled:
          this.$store.state.masters.browsingAccountFlg ||
          this.$store.state.adminAccounts.adminAccountMasterAuthorityFlg ||
          this.$store.state.masters.loginUser.adminUserId ===
            this.$store.state.adminAccounts.adminAccount.adminUserId,
        class: {
          disabledColor:
            this.$store.state.masters.browsingAccountFlg ||
            this.$store.state.adminAccounts.adminAccountMasterAuthorityFlg ||
            this.$store.state.masters.loginUser.adminUserId ===
              this.$store.state.adminAccounts.adminAccount.adminUserId
        }
      }
    }
  },
  computed: {
    adminAccount() {
      return this.$store.state.adminAccounts.adminAccount
    },
    isAdminUserAuthority() {
      return this.$store.state.adminAccounts.adminAccountMasterAuthorityFlg
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    requiredItemLabel() {
      return this.$store.state.error.requiredItemLabel
    },
    browsingAccountFlg() {
      return this.$store.state.masters.browsingAccountFlg
    },
    loginUserAuthority() {
      return this.$store.state.masters.loginUser.authority
    },
    loginUserId() {
      return this.$store.state.masters.loginUser.adminUserId
    }
  },
  components: {
    deleteModalWindow,
    changePasswordModalWindow,
    completeModalWindow,
    loadingModalWindow
  },
  methods: {
    inputUpdate(e) {
      this.$store.dispatch('adminAccounts/inputUpdate', {
        name: e,
        value: event.target.value
      })
    },
    async cancel(e) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch(
          'adminAccounts/setDetailAdminAccount',
          this.$store.state.adminAccounts.adminAccount
        )
        this.$router.push('../adminAccounts/detail')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_310001
        let eventType = 3
        let reason = 'MSGCRC0070 '
        if (error.response) {
          this.failureWord =
            this.errorMsg.MSGCRC0070.name +
            this.errorMsg.MSGCRC0070.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    async update(e) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch('adminAccounts/updateAdminAccount')
        this.$emit('list-reload')
        this.$router.push('../adminAccounts/detail')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_310003
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message
          if (errorMessage === 'MSGCRC0064') {
            this.failureWord =
              this.errorMsg.MSGCRC0064.name +
              this.errorMsg.MSGCRC0064.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0065') {
            this.failureWord =
              this.errorMsg.MSGCRC0065.name +
              this.errorMsg.MSGCRC0065.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0066') {
            this.failureWord =
              this.errorMsg.MSGCRC0066.name +
              this.errorMsg.MSGCRC0066.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0094') {
            this.failureWord =
              this.errorMsg.MSGCRC0094.name +
              this.errorMsg.MSGCRC0094.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0110') {
            this.failureWord =
              this.errorMsg.MSGCRC0110.name +
              this.errorMsg.MSGCRC0110.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0111') {
            this.failureWord =
              this.errorMsg.MSGCRC0111.name +
              this.errorMsg.MSGCRC0111.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0127') {
            this.failureWord =
              this.errorMsg.MSGCRC0127.name +
              this.errorMsg.MSGCRC0127.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else {
            this.failureWord =
              this.errorMsg.MSGCRC0071.name +
              this.errorMsg.MSGCRC0071.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason = errorMessage + ' '
          reason += error.response.status
        } else if (error.response && error.response.data) {
          reason = 'MSGCRC0071'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0071.name +
            this.errorMsg.MSGCRC0071.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      try {
        let adminUserId = this.$store.state.adminAccounts.adminAccount
          .adminUserId
        await this.$store.dispatch('adminAccounts/setDetailAdminAccount', {
          adminUserId: adminUserId
        })
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_310002
        let eventType = 3
        let reason = 'MSGCRC0070 '
        if (error.response) {
          this.failureWord =
            this.errorMsg.MSGCRC0070.name +
            this.errorMsg.MSGCRC0070.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    close(e) {
      this.showDeleteModal = false
      this.showChangePasswordModal = false
      this.showCompleteModal = false
      this.$router.push(this.router)
    },
    stayClose(e) {
      this.showDeleteModal = false
      this.showChangePasswordModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
    },
    async remove(e) {
      this.showloadingModal = true
      let adminUserId = this.$store.state.adminAccounts.adminAccount.adminUserId
      let deleteList = [{adminUserId}]
      try {
        await this.$store.dispatch(
          'adminAccounts/deleteAdminAccounts',
          deleteList
        )
        this.$emit('list-reload')
        this.showDeleteModal = false
        this.completeWord = '削除しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_310004
        let eventType = 3
        let reason = 'MSGCRC0072 '
        if (error.response) {
          this.failureWord =
            this.errorMsg.MSGCRC0072.name +
            this.errorMsg.MSGCRC0072.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showDeleteModal = false
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    change(e) {
      this.showChangePasswordModal = false
    }
  }
}
</script>

<style scoped>
.password_change {
  width: 100%;
  height: 100%;
}
.password_change_button {
  color: #fff;
  background-color: #00afa8;
  width: 50%;
  height: 30px;
  border: none;
}
.disabledColor {
  background-color: rgba(200, 200, 200, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/adminAccounts/adminAccountEdit.vue